import { render } from "./DetailMerchantModal.vue?vue&type=template&id=0eb2540b&scoped=true"
import script from "./DetailMerchantModal.vue?vue&type=script&lang=js"
export * from "./DetailMerchantModal.vue?vue&type=script&lang=js"

import "./DetailMerchantModal.vue?vue&type=style&index=0&id=0eb2540b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb2540b"]])

export default __exports__